import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const MailIcon: React.FC<IStyledSVGIconProps> = props => {
  return (
    <StyledSVGIcon
      xmlns="http://www.w3.org/2000/svg"
      width="25" 
      height="15" 
      viewBox="0 0 25 15" 
      fill="none"
      {...props}
    >
    <g fill="#918EFA">
    <path d="M1 1H24V14H1V1Z" fill="#918EFA"/>
    <path d="M1 1L12.4602 8.904L24 1M1 1H24M1 1V14H24V1" stroke="white" fill="none"/>
    </g>
    </StyledSVGIcon>
  );
};